export const getPersonNameInitials = (name: string) => {
  return name
    .replace(/[^a-zA-Z- ]/g, '')
    .match(/\b\w/g)
    ?.join('');
};
